<mat-toolbar color="primary">
    <mat-toolbar-row fxLayout="row">
        <span class="title-center">Forgot Password?</span>
    </mat-toolbar-row>
</mat-toolbar>
<mat-dialog-content class="mat-typography">
    <form [formGroup]="forgotPasswordForm">
        <div fxFlex fxLayout="column">
            <mat-form-field appearance="fill" fxFlex>
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" required>
                <mat-error
                    *ngIf="forgotPasswordForm.controls.email.touched && forgotPasswordForm.controls.email.invalid">
                    <span *ngIf="forgotPasswordForm.controls.email.errors.required">This field is mandatory.</span>
                    <span *ngIf="forgotPasswordForm.controls.email.errors.pattern">This field is invalid.</span>
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-raised-button color="primary" type="submit" (click)="handleSubmit()"
        [disabled]="!(forgotPasswordForm.valid && forgotPasswordForm.dirty)">Send Password</button>
    <button mat-raised-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>